module.exports = __webpack_public_path__ + "static/media/Vector.1e2f7932.svg";